<template>
  <div>
    <div class="row">
      <div :class="['col_12', { loading_overlay: loading }]">
        <div class="card no_border">
          <div class="card-header">
            <div class="card-title">{{ title }}</div>
          </div>
          <div class="card-body pl_0 pr_0">
            <div class="d_flex_end form_action_btn">
              <router-link
                class="btn btn_blue ml_10"
                :to="{
                  name: 'special_lecture_list',
                  params: { id: $route.params.id },
                }"
                >{{ $t('common.back') }}</router-link
              >
            </div>

            <div class="row">
              <div class="col_3">
                <div
                  :class="['form-group', { has_error: errorFor('subject_id') }]"
                >
                  <label>{{ $t('common.subject') }}</label>
                  <select v-model="form.subject_id" class="form_global">
                    <option value="">{{ $t('common.select_subject') }}</option>
                    <option
                      :value="subject.id"
                      v-for="subject in subjects"
                      :key="'subject_' + subject.id"
                    >
                      {{ subject.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('subject_id')" />
                </div>
              </div>
              <div class="col_3">
                <div
                  :class="['form-group', { has_error: errorFor('grade_id') }]"
                >
                  <label>{{ $t('common.grade') }}</label>
                  <select
                    v-model="form.grade_id"
                    class="form_global"
                    :disabled="form.grade_group_id != ''"
                  >
                    <option value="">{{ $t('common.select_grade') }}</option>
                    <option
                      :value="grade.id"
                      v-for="grade in grades"
                      :key="'grade ' + grade.id"
                    >
                      {{ grade.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('grade_id')" />
                </div>
              </div>

              <div class="col_3">
                <div
                  :class="[
                    'form-group',
                    { has_error: errorFor('semester_id') },
                  ]"
                >
                  <label>{{ $t('common.semester') }}</label>
                  <select
                    v-model="form.semester_id"
                    class="form_global"
                    :disabled="form.grade_group_id != ''"
                  >
                    <option value="">{{ $t('common.select_semester') }}</option>
                    <option
                      :value="semester.id"
                      v-for="semester in semesters"
                      :key="'semester ' + semester.id"
                    >
                      {{ semester.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('semester_id')" />
                </div>
              </div>
              <div class="col_3">
                <div
                  :class="[
                    'form-group',
                    { has_error: errorFor('grade_group_id') },
                  ]"
                >
                  <label>{{ $t('special_lecture.grade_group.title') }}</label>
                  <select
                    v-model="form.grade_group_id"
                    class="form_global"
                    :disabled="form.grade_id != '' || form.semester_id != ''"
                  >
                    <option value="">
                      {{ $t('special_lecture.grade_group.select_grade_group') }}
                    </option>
                    <option
                      :value="grade_group.id"
                      v-for="grade_group in grade_groups"
                      :key="'grade_group ' + grade_group.id"
                    >
                      {{ grade_group.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('grade_group_id')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col_3">
                <div
                  :class="[
                    'form-group',
                    { has_error: errorFor('learning_goal') },
                  ]"
                >
                  <label>{{ $t('sidebar.lectureCommon.learning_goal') }}</label>
                  <input
                    type="text"
                    class="form_global"
                    v-model="form.learning_goal"
                  />
                  <v-errors :errors="errorFor('learning_goal')" />
                </div>
              </div>
              <div class="col_3">
                <div :class="['form-group', { has_error: errorFor('sort') }]">
                  <label>{{ $t('special_lecture.exposure_order') }}</label>
                  <input
                    type="number"
                    class="form_global"
                    v-model="form.sort"
                  />
                  <v-errors :errors="errorFor('sort')" />
                </div>
              </div>
              <div class="col_3">
                <div :class="['form-group', { has_error: errorFor('status') }]">
                  <label>{{
                    $t('special_lecture.special_lecture_category.status')
                  }}</label>
                  <div class="form_inline">
                    <div class="form_radio">
                      <input
                        type="radio"
                        id="active"
                        value="1"
                        v-model="form.status"
                      />
                      <label for="active">{{
                        $t('special_lecture.special_lecture_category.active')
                      }}</label>
                    </div>
                    <div class="form_radio">
                      <input
                        type="radio"
                        id="inactive"
                        value="0"
                        v-model="form.status"
                      />
                      <label for="inactive">{{
                        $t('special_lecture.special_lecture_category.inactive')
                      }}</label>
                    </div>
                  </div>
                  <v-errors :errors="errorFor('status')" />
                </div>
              </div>
              <div class="col_3">
                <div class="form-group">
                  <label>{{ $t('sidebar.lectureCommon.lecture_image') }}</label>
                  <input
                    type="file"
                    class="form_global"
                    ref="lecture_image"
                    @input="onFileChange($event)"
                    accept="image/png, image/gif, image/jpeg, image/webp"
                  />
                  <v-errors :errors="errorFor('lecture_image')"></v-errors>
                </div>
                <div
                  class="thumbnail_img"
                  v-if="tempLectureImage || form.lecture_image"
                >
                  <div class="inner">
                    <img
                      v-if="tempLectureImage"
                      :src="tempLectureImage"
                      alt=""
                    />
                    <img v-else :src="form.lecture_image" alt="" />
                    <span
                      class="close_icon"
                      @click="removeTempLectureImage"
                    ></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col_12">
                <div class="custom_tabs">
                  <nav class="tabs">
                    <ul class="">
                      <li href="#video" class="active">
                        {{ $t('special_lecture.video_or_image') }}
                      </li>
                      <li href="#exams">{{ $t('sidebar.exams.exams') }}</li>
                      <li href="#attachment">
                        {{ $t('special_lecture.attachment') }}
                      </li>
                    </ul>
                  </nav>
                  <div class="tab_content_wrapper">
                    <div id="video" class="tab_content show">
                      <div class="fadein">
                        <div class="custom_tab_content_inner">
                          <div class="row">
                            <div class="col_3">
                              <div :class="['form-group']">
                                <label>{{
                                  $t(
                                    'special_lecture.special_lecture_category.status'
                                  )
                                }}</label>
                                <div class="form_inline">
                                  <div class="form_radio">
                                    <input
                                      type="radio"
                                      id="video_file"
                                      value="1"
                                      v-model="selectedFileType"
                                    />
                                    <label for="video_file">{{
                                      $t('special_lecture.video')
                                    }}</label>
                                  </div>
                                  <div class="form_radio">
                                    <input
                                      type="radio"
                                      id="image_file"
                                      value="0"
                                      v-model="selectedFileType"
                                    />
                                    <label for="image_file">{{
                                      $t('special_lecture.image')
                                    }}</label>
                                  </div>
                                </div>
                                <v-errors :errors="errorFor('status')" />
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="selectedFileType == 1">
                            <div class="col_12">
                              <div class="add_new d_flex_end">
                                <button
                                  class="btn btn_blue ml_20 width_150p"
                                  @click="openVideoUploadModal()"
                                >
                                  <i class="lni lni-plus"></i
                                  >{{ $t('common.add') }}
                                  {{ $t('common.video') }}
                                </button>
                              </div>
                            </div>
                            <div class="col_12">
                              <div class="video_list">
                                <div
                                  class="inner"
                                  v-for="(
                                    preview_video, index
                                  ) in lecture_preview_videos"
                                  :key="index"
                                >
                                  <div
                                    class="inner_wrap"
                                    v-if="preview_video.convert_status"
                                  >
                                    <img
                                      :src="
                                        form.lecture_image
                                          ? form.lecture_image
                                          : preview_video.thumbs
                                      "
                                      alt=""
                                      v-if="preview_video.smil"
                                    />
                                    <img
                                      :src="
                                        baseUrl + 'assets/images/no_image.jpg'
                                      "
                                      alt=""
                                      v-else
                                    />
                                    <div class="icons">
                                      <span
                                        v-if="preview_video.smil"
                                        @click.prevent="
                                          showVideo(preview_video.smil)
                                        "
                                        ><i class="lni lni-eye"></i
                                      ></span>
                                      <span
                                        ><i
                                          class="lni lni-pencil"
                                          @click.prevent="
                                            editVideo(preview_video)
                                          "
                                        ></i
                                      ></span>
                                      <span
                                        ><i
                                          class="lni lni-trash"
                                          @click.prevent="
                                            removeVideo(preview_video)
                                          "
                                        ></i
                                      ></span>
                                    </div>
                                  </div>
                                  <div class="inner_wrap" v-else>
                                    <img
                                      :src="
                                        baseUrl + 'assets/images/no_image.jpg'
                                      "
                                      alt=""
                                    />
                                    <div class="icons">
                                      <span
                                        ><i
                                          class="lni lni-pencil"
                                          @click.prevent="
                                            editVideo(preview_video)
                                          "
                                        ></i
                                      ></span>
                                      <span
                                        ><i
                                          class="lni lni-trash"
                                          @click.prevent="
                                            removeVideo(preview_video)
                                          "
                                        ></i
                                      ></span>
                                    </div>
                                  </div>
                                  <span
                                    class="video_type"
                                    v-if="preview_video.video_url"
                                    >URL</span
                                  >
                                  <span class="video_type" v-else>Video</span>

                                  <div class="form-group" style="width: 230px">
                                    <label>{{
                                      $t('sidebar.exams.video_intro')
                                    }}</label>
                                    <input
                                      v-if="preview_video.video_url"
                                      type="number"
                                      v-model="
                                        lecture_video_url[index].video_intro
                                      "
                                      class="form_global"
                                    />
                                    <input
                                      v-else
                                      type="number"
                                      v-model="
                                        lecture_videos[index].video_intro
                                      "
                                      class="form_global"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="selectedFileType == 0">
                            <div class="col_12">
                              <div
                                class="add_new d_flex_end"
                                v-if="!form.images"
                              >
                                <button
                                  class="btn btn_blue ml_20 width_150p"
                                  @click="openImageUploadModal()"
                                >
                                  <i class="lni lni-plus"></i
                                  >{{ $t('common.add') }}
                                  {{ $t('special_lecture.add_image') }}
                                </button>
                              </div>
                              <div class="custom_tab_table" v-if="form.images">
                                <table class="table">
                                  <tr>
                                    <th>{{ $t('special_lecture.title') }}</th>
                                    <th>
                                      {{ $t('special_lecture.explanation') }}
                                    </th>
                                    <th>
                                      {{ $t('special_lecture.main_text') }}
                                    </th>
                                    <th>
                                      <div class="d_flex_end">
                                        {{ $t('common.action') }}
                                      </div>
                                    </th>
                                  </tr>
                                  <tr>
                                    <td>{{ form.images.title }}</td>
                                    <td>{{ form.images.explanation }}</td>
                                    <td>
                                      <div
                                        class="text_shorten"
                                        v-html="
                                          convertTextEditor(
                                            form.images.main_text
                                          )
                                        "
                                      ></div>
                                    </td>
                                    <td>
                                      <div class="d_flex_end">
                                        <button
                                          class="btn btn_blue ml_10"
                                          @click.prevent="editUploadedImage()"
                                        >
                                          <img
                                            :src="`${baseUrl}assets/media/images/icon/8.png`"
                                            alt=""
                                          />
                                        </button>
                                        <button
                                          class="btn btn_danger ml_10"
                                          @click="removeUploadedImage()"
                                        >
                                          <img
                                            :src="`${baseUrl}assets/media/images/icon/9.png`"
                                            alt=""
                                          />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="exams" class="tab_content">
                      <div class="fadein">
                        <div class="custom_tab_content_inner">
                          <div class="add_new d_flex_end">
                            <button
                              class="btn btn_blue ml_20 width_150p"
                              @click="openModalWithType('special_exams')"
                            >
                              <i class="lni lni-plus"></i
                              >{{ $t('sidebar.exams.add_exam') }}
                            </button>
                          </div>
                          <div class="custom_tab_table">
                            <table class="table">
                              <tr>
                                <th>{{ $t('common.title') }}</th>
                                <th>{{ $t('sidebar.exams.exam_time') }}</th>
                                <th>
                                  <div class="d_flex_end">
                                    {{ $t('common.action') }}
                                  </div>
                                </th>
                              </tr>
                              <tr
                                v-for="(
                                  exam, index
                                ) in selectedSpecialLectureExams"
                                :key="index"
                              >
                                <td>{{ exam.title }}</td>
                                <td>
                                  {{ exam.exam_time }}
                                  {{ $t('sidebar.lectureCommon.minute') }}
                                </td>
                                <td>
                                  <div class="d_flex_end">
                                    <button
                                      class="btn btn_danger ml_10"
                                      @click="removeExam(exam.id)"
                                    >
                                      <img
                                        :src="`${baseUrl}assets/media/images/icon/9.png`"
                                        alt=""
                                      />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </div>
                          <v-errors :errors="errorFor('exam_id')" />
                        </div>
                      </div>
                    </div>
                    <div id="attachment" class="tab_content">
                      <div class="fadein">
                        <div
                          class="custom_tab_content_inner"
                          :class="[{ has_error: errorFor('attachments') }]"
                        >
                          <div class="product_list_wrap">
                            <div class="upload_btn dropzone-clickable">
                              <button class="btn btn_blue width_150p">
                                업로드
                              </button>
                            </div>
                            <div class="product_list">
                              <draggable
                                :list="form.attachments"
                                item-key="image"
                                tag="ul"
                                ghost-class="ghost"
                                @end="imageSorted"
                              >
                                <template #item="{ element, index }">
                                  <li>
                                    <div class="inner">
                                      <div class="img">
                                        <template
                                          v-if="
                                            [
                                              'gif',
                                              'png',
                                              'jpg',
                                              'jpeg',
                                              'JPG',
                                            ].includes(element.ext)
                                          "
                                        >
                                          <div
                                            class="cross_ic"
                                            @click="removeImage(element, index)"
                                          >
                                            <i class="fas fa-times"></i>
                                          </div>
                                          <img :src="element.image_path" />
                                        </template>
                                        <template
                                          v-if="['pdf'].includes(element.ext)"
                                        >
                                          <div
                                            class="cross_ic"
                                            @click="removeImage(element, index)"
                                          >
                                            <i class="fas fa-times"></i>
                                          </div>
                                          <embed :src="element.image_path" />
                                        </template>
                                        <template
                                          v-if="
                                            [
                                              'xls',
                                              'xlsx',
                                              'xlm',
                                              'xla',
                                              'xlc',
                                              'xlt',
                                              'xlw',
                                              'csv',
                                            ].includes(element.ext)
                                          "
                                        >
                                          <div
                                            class="cross_ic"
                                            @click="removeImage(element, index)"
                                          >
                                            <i class="fas fa-times"></i>
                                          </div>
                                          <i
                                            class="fas fa-file-excel fa-10x"
                                          ></i>
                                        </template>
                                        <template
                                          v-if="['docx'].includes(element.ext)"
                                        >
                                          <div
                                            class="cross_ic"
                                            @click="removeImage(element, index)"
                                          >
                                            <i class="fas fa-times"></i>
                                          </div>
                                          <i
                                            class="fas fa-file-word fa-10x"
                                          ></i>
                                        </template>
                                        <template
                                          v-if="['pptx'].includes(element.ext)"
                                        >
                                          <div
                                            class="cross_ic"
                                            @click="removeImage(element, index)"
                                          >
                                            <i class="fas fa-times"></i>
                                          </div>
                                          <i
                                            class="fas fa-file-powerpoint fa-10x"
                                          ></i>
                                        </template>
                                        <template
                                          v-if="['zip'].includes(element.ext)"
                                        >
                                          <div
                                            class="cross_ic"
                                            @click="removeImage(element, index)"
                                          >
                                            <i class="fas fa-times"></i>
                                          </div>
                                          <i
                                            class="fas fa-file-archive fa-10x"
                                          ></i>
                                        </template>
                                        <input
                                          type="text"
                                          class="form_global color_black"
                                          :class="[
                                            {
                                              red_border: errorFor(
                                                'attachments.' +
                                                  index +
                                                  '.title'
                                              ),
                                            },
                                          ]"
                                          v-model="
                                            form.attachments[index].title
                                          "
                                        />
                                        <!-- <template v-if="allErrors && allErrors['attachments.'+index]">
                                                                                    pgh
                                                                                    <small v-for="(error, errorIndex) in allErrors['attachments.'+index]" :key="'error_' + index + '_attachments_'+errorIndex">{{error}}</small>
                                                                                </template> -->
                                      </div>
                                    </div>
                                  </li>
                                </template>
                              </draggable>
                            </div>
                            <div class="dropzone-previews"></div>
                            <div class="dropzone_wrap">
                              <div
                                class="create_images_drag dropzone-clickable dropzone-container"
                              >
                                <div class="images">
                                  <span>컴퓨터에서 이미지 끌어다 놓기</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d_flex_end form_action_btn">
              <router-link
                class="btn btn_danger ml_10"
                :to="{
                  name: 'special_lecture_list',
                  params: { id: $route.params.id },
                }"
                >{{ $t('common.cancel') }}</router-link
              >
              <button class="btn btn_blue ml_10" @click.prevent="submit">
                {{ $t('common.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <exam-modal
      v-if="openModal"
      :openModal="openModal"
      :subject_id="form.subject_id"
      :grade_id="form.grade_id"
      :semester_id="form.semester_id"
      :unit_id="''"
      :type="type"
      @specialLectureExamData="specialLectureExamData"
      @closeModal="closeModal"
    >
    </exam-modal>

    <video-modal
      v-if="videoModalShow"
      :showVideoModal="videoModalShow"
      :video="videoSmilFile"
      @closeModal="closeModal()"
    ></video-modal>

    <div class="modal" :class="{ open_modal: showVideoUploadModal }">
      <div class="modal_overlay"></div>
      <div class="modal_inner max_height_80">
        <div class="modal_header">
          <span class="close_icon close_icon_sm" @click="closeModal()">×</span>
          <h2>{{ $t('special_lecture.video') }}</h2>
        </div>
        <div class="modal_wrapper">
          <div class="modal_content modal_1080p">
            <div class="container">
              <div class="row">
                <div :class="['col_12', { d_none: isEditVideo }]">
                  <div
                    :class="[
                      'form-group',
                      { has_error: errorFor('upload_type') },
                    ]"
                  >
                    <label>동영상 업로드 유형</label>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input
                          type="radio"
                          id="video_upload_type"
                          value="1"
                          v-model="video_upload_type"
                        />
                        <label for="video_upload_type">{{
                          $t('common.video')
                        }}</label>
                      </div>
                      <div class="form_radio">
                        <input
                          type="radio"
                          id="url"
                          value="2"
                          v-model="video_upload_type"
                        />
                        <label for="url">URL</label>
                      </div>
                    </div>
                    <v-errors :errors="errorFor('upload_type')" />
                  </div>
                </div>
                <div class="col_12" v-if="video_upload_type == 1">
                  <div
                    :class="[
                      'form-group',
                      { has_error: errorFor('lecture_videos') },
                    ]"
                  >
                    <label>
                      <h4>{{ $t('sidebar.lectureCommon.video') }}</h4>
                    </label>
                    <vue-dropzone
                      ref="myVueDropzone"
                      id="dropzone"
                      :class="{ dropzone_disable: dropzoneDisable }"
                      @vdropzone-removed-file="vremoved"
                      @vdropzone-success-multiple="vSuccessMultiple"
                      :options="dropzoneOptions"
                      :duplicateCheck="true"
                    >
                    </vue-dropzone>

                    <v-errors :errors="errorFor('lecture_videos')"></v-errors>
                  </div>
                </div>
                <div class="col_12" v-if="video_upload_type == 2">
                  <div
                    :class="[
                      'form-group',
                      { has_error: errorFor('video_url') },
                    ]"
                  >
                    <label>URL</label>
                    <input
                      type="text"
                      class="form_global"
                      v-model="temp_video_url"
                    />
                    <v-errors :errors="errorFor('video_url')"></v-errors>
                  </div>
                </div>

                <div class="col_12">
                  <div
                    :class="[
                      'form-group',
                      { has_error: errorFor('video_name') },
                    ]"
                  >
                    <label>{{ $t('common.video_name') }}</label>
                    <input
                      type="text"
                      class="form_global"
                      v-model="form.video_name"
                    />
                    <v-errors :errors="errorFor('video_name')" />
                  </div>
                </div>

                <div class="col_12">
                  <div
                    :class="[
                      'form-group',
                      { has_error: errorFor('lecture_information') },
                    ]"
                  >
                    <label>{{
                      $t('sidebar.lectureCommon.lecture_information')
                    }}</label>
                    <text-editor-component
                      :id="'lecture_information'"
                      :existingData="
                        form.lecture_information ? form.lecture_information : ''
                      "
                      @change="changeEditorValue"
                    />
                    <v-errors :errors="errorFor('lecture_information')" />
                  </div>
                </div>

                <div class="col_12">
                  <div class="d_flex_end">
                    <button
                      class="btn btn_blue ml_10 add_update"
                      @click.prevent="addUploadVideo()"
                    >
                      Add Video
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ImageUploadModalVue
      v-if="showImageUploadModal"
      :showImageUploadModal="showImageUploadModal"
      :editableImageData="form.images"
      @addUploadedImage="addUploadedImage"
      @closeModal="closeImageUploadModal"
    />
  </div>
</template>

<script>
import Dropzone from 'dropzone';
import TextEditorComponent from '@/components/TextEditorComponent';
import ExamModal from '../components/ExamModal.vue';
import VideoModal from '../components/VideoModal';
import vueDropzone from '../components/dropzone';
import draggable from 'vuedraggable';
import ImageUploadModalVue from './ImageUploadModal.vue';
export default {
  components: {
    TextEditorComponent,
    ExamModal,
    VideoModal,
    vueDropzone,
    draggable,
    ImageUploadModalVue,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      title: this.$t('special_lecture.create_new_lecture'),
      subjects: [],
      grades: [],
      semesters: [],
      grade_groups: [],
      selectedFileType: 1,
      form: {
        status: 1,
        sort: '',
        subject_id: '',
        grade_id: '',
        semester_id: '',
        grade_group_id: '',
        learning_goal: '',
        exam_id: [],
        video_name: '',
        lecture_information: '',
        attachments: [],
        images: null,
        lecture_image: '',
        video_intro: '',
      },
      selectedSpecialLectureExams: [],
      selectedExams: [],
      specialExamRemovableIds: [],
      openModal: false,
      type: '',
      examCheckedAllStatus: false,
      lecture_video_url: [],
      lecture_videos: [],
      lecture_preview_videos: [],
      videoSmilFile: null,
      videoModalShow: false,
      showVideoUploadModal: false,
      isUpload: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_BASE_URL}/upload/video`,
        thumbnailWidth: 150,
        maxFiles: 1,
        maxFilesize: 5368709120,
        uploadMultiple: true,
        allowMultiple: true,
        addRemoveLinks: true,
        acceptedFiles: 'video/*',
        headers: {
          Authorization:
            `Bearer ` + JSON.parse(localStorage.getItem('admin')).token,
        },
      },
      dropzoneDisable: false,
      video_upload_type: 1,
      isTempFile: false,
      temp_lecture_video: '',
      temp_lecture_original_video: '',
      temp_lecture_preview_video: '',
      temp_video_url: '',
      editValue: '',
      isEditVideo: false,
      errors: {},
      showImageUploadModal: false,
      tempLectureImage: '',
    };
  },
  created() {
    this.axios
      .get('/subjects')
      .then((response) => (this.subjects = response.data.data));
    this.axios
      .get('/grades')
      .then((response) => (this.grades = response.data.data));
    this.axios
      .get('/semesters')
      .then((response) => (this.semesters = response.data.data));
    this.axios
      .get('/grade-groups')
      .then((response) => (this.grade_groups = response.data.data));

    if (this.$route.name === 'special_lecture_edit') {
      this.axios
        .get('/special-lectures/' + this.$route.params.lecture_id)
        .then((response) => {
          let videoData = response.data.data;
          this.form.subject_id = videoData.subject ? videoData.subject.id : '';
          this.form.grade_id = videoData.grade ? videoData.grade.id : '';
          this.form.semester_id = videoData.semester
            ? videoData.semester.id
            : '';
          this.form.grade_group_id = videoData.grade_group
            ? videoData.grade_group.id
            : '';
          this.form.learning_goal = videoData.learning_goal;
          this.form.sort = videoData.sort;
          this.form.status = videoData.status ? '1' : '0';
          this.form.video_name = videoData.video_name;
          this.form.lecture_information = videoData.lecture_information;
          this.form.attachments = videoData.attachments;
          this.form.lecture_image = videoData.lecture_image;

          if (videoData.lectureVideos && videoData.lectureVideos.length > 0) {
            this.selectedFileType = 1;
          } else if (videoData.images) {
            this.selectedFileType = 0;
            this.form.images = videoData.images;
          } else {
            this.selectedFileType = 1;
          }

          if (videoData.special_exams) {
            let specialLecturesExamData = [];
            videoData.special_exams.forEach((element) => {
              if (element.exam) {
                specialLecturesExamData.push(element.exam);
              }
            });

            this.selectedSpecialLectureExams = specialLecturesExamData;
          }

          let lectureVideoList = videoData.lectureVideos;
          if (lectureVideoList && lectureVideoList.length > 0) {
            this.lecture_preview_videos = lectureVideoList;
            if (this.lecture_preview_videos.length >= 1) {
              this.dropzoneDisable = true;
            }
            lectureVideoList.forEach((element) => {
              if (element.video_url) {
                let lectureUrlVideo = {
                  video_url: element.video_url,
                  video_intro: element.video_intro,
                  lecture_information: element.lecture_information,
                  video_name: element.video_name,
                };
                this.lecture_video_url.push(lectureUrlVideo);
              }

              if (element.video_url == null) {
                let lectureOriginalFile = {
                  file: element.filename,
                  original_file: element.original_filename,
                  lecture_information: element.lecture_information,
                  video_name: element.video_name,
                  video_intro: element.video_intro,
                };
                this.lecture_videos.push(lectureOriginalFile);
              }
            });
            this.form.video_intro = this.lecture_preview_videos[0]?.video_intro;
          }
        });
      this.title = this.$t('special_lecture.edit_lecture');
    }
  },
  mounted() {
    let that = this;
    const user = JSON.parse(localStorage.getItem('admin')) || null;
    // for image.
    new Dropzone('.dropzone-container', {
      clickable: '.dropzone-clickable',
      disablePreviews: true, // will not show preview
      createImageThumbnails: true,
      addRemoveLinks: true,
      previewsContainer: '.dropzone-previews',
      maxFiles: 2000,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      url: `${process.env.VUE_APP_API_BASE_URL}/temporary-image-upload`,
      // url: (process.env.VUE_APP_API_BASE_URL + '/temporary-image-upload'),
      success: function (file, response) {
        let image = {
          id: '',
          sort: that.form.attachments.length + 1,
          draft: response.draft,
          ext: response.ext,
          image_path: response.image_path,
        };
        that.form.attachments.push(image);
        // since no preview there is nothing to remove
        // this.removeFile(file); // This line removes the preview
      },
      error: function (file, response) {
        let errors = that.errors ? that.errors : {};
        errors.attachments =
          errors && errors.attachments ? errors.attachments : [];
        errors.attachments = response.errors.file;
        that.errors = errors;
        // this.removeFile(file);
      },
      removedfile: function () {
        let errors = that.errors ? that.errors : {};
        errors.attachments = null;
        that.errors = errors;
        // since no preview there is nothing to remove
        // file.previewElement.remove();
      },
    });
  },
  watch: {
    examCheckedAllStatus: function () {
      if (this.examCheckedAllStatus) {
        this.specialExamRemovableIds = this.selectedSpecialLectureExams.map(
          (i) => i.id
        );
      } else {
        this.specialExamRemovableIds = [];
      }
    },
  },
  methods: {
    onFileChange(e) {
      this.form.lecture_image = e.target.files[0];
      this.tempLectureImage = URL.createObjectURL(e.target.files[0]);
    },
    removeTempLectureImage() {
      this.tempLectureImage = '';
      this.form.lecture_image = '';
      this.$refs.lecture_image.value = null;
    },
    convertTextEditor(string) {
      let parser = new DOMParser();
      const doc = parser.parseFromString(string, 'text/html');
      let mathTags = doc.getElementsByTagName('math');
      if (mathTags.length > 0) {
        [...mathTags].forEach((mathTag) => {
          mathTag.replaceWith(this.getLatex(mathTag.outerHTML));
        });

        return doc.body.innerHTML.replace(/<img[^>]*>/g, '');
      } else {
        return string ? string.replace(/<img[^>]*>/g, '') : '';
      }
    },
    removeImage(element, index) {
      if (!this.form) return;
      if (!this.form.attachments) return;
      if (!element.id) {
        let formData = new FormData();
        formData.append('draft', element.draft);
        this.axios.post('/temporary-image-remove', formData).then(() => {});
      }
      this.form.attachments.splice(index, 1);
      this.imageSorted();
    },
    imageSorted() {
      let sort = 1;
      for (let index = 0; index < this.form.attachments.length; index++) {
        this.form.attachments[index].sort = sort++;
      }
    },
    changeEditorValue(editorId, data) {
      this.form[editorId] = data;
    },
    vremoved(file) {
      if (!this.isTempFile) {
        let index = this.lecture_videos.findIndex((object) => {
          return object.original_file === file.name;
        });
        if (index !== -1) {
          this.lecture_videos.splice(index, 1);
        }

        this.temp_lecture_video = '';
        this.temp_lecture_original_video = '';
      }
    },
    vSuccessMultiple(file, response) {
      this.temp_lecture_video = file;
      this.temp_lecture_original_video = response;
      if (this.lecture_preview_videos.length >= 1) {
        this.dropzoneDisable = true;
      } else {
        this.dropzoneDisable = false;
      }
    },
    openVideoUploadModal() {
      this.editValue = '';
      this.isEditVideo = false;
      this.showVideoUploadModal = true;
      this.form.lecture_information = '';
      this.form.video_name = '';
      this.video_upload_type = 1;
      window.$('.add_update').text('Add Video');

      if (this.lecture_preview_videos.length >= 1) {
        this.dropzoneDisable = true;
      } else {
        this.dropzoneDisable = false;
      }
    },
    openImageUploadModal() {
      this.showImageUploadModal = true;
    },
    closeImageUploadModal() {
      this.showImageUploadModal = false;
    },
    addUploadedImage(value) {
      this.form.images = value;
      this.showImageUploadModal = false;
    },
    editUploadedImage() {
      this.showImageUploadModal = true;
    },
    removeUploadedImage() {
      this.form.images = null;
    },
    removeExam(id) {
      this.selectedExams = [];

      this.selectedExams = this.selectedSpecialLectureExams;

      var index = this.selectedExams.findIndex((object) => {
        return object.id === id;
      });
      if (index !== -1) this.selectedExams.splice(index, 1);

      if (!this.selectedExams.length) {
        this.examCheckedAllStatus = false;
      }
    },
    removeVideo(video) {
      let videoId = video.id;

      if (video.video_url) {
        let lecturePreviewIndex = this.lecture_preview_videos.findIndex(
          (object) => {
            return object.video_url == video.video_url;
          }
        );

        if (lecturePreviewIndex > -1) {
          this.lecture_preview_videos.splice(lecturePreviewIndex, 1);
        }

        let lectureVideoUrlIndex = this.lecture_video_url.findIndex(
          (object) => {
            return object.video_url === video.video_url;
          }
        );
        if (lectureVideoUrlIndex > -1) {
          this.lecture_video_url.splice(lectureVideoUrlIndex, 1);
        }
      } else {
        if (video.file) {
          let lecturePreviewIndex = this.lecture_preview_videos.findIndex(
            (object) => {
              return object.file === video.file;
            }
          );

          if (lecturePreviewIndex > -1) {
            this.lecture_preview_videos.splice(lecturePreviewIndex, 1);
          }

          let lectureVideoIndex = this.lecture_videos.findIndex((object) => {
            return object.file === video.file;
          });

          if (lectureVideoIndex > -1) {
            this.lecture_videos.splice(lectureVideoIndex, 1);
          }
        } else {
          let lecturePreviewIndex = this.lecture_preview_videos.findIndex(
            (object) => {
              return object.filename === video.filename;
            }
          );

          if (lecturePreviewIndex > -1) {
            this.lecture_preview_videos.splice(lecturePreviewIndex, 1);
          }

          let lectureVideoIndex = this.lecture_videos.findIndex((object) => {
            return object.filename === video.filename;
          });

          if (lectureVideoIndex > -1) {
            this.lecture_videos.splice(lectureVideoIndex, 1);
          }
        }
      }

      this.axios.post('/delete-lecture-video', { id: videoId }).then(() => {
        this.showSuccessMsg('Video Removed Successfully!');
        if (this.lecture_preview_videos.length > 2) {
          this.dropzoneDisable = true;
        } else {
          this.dropzoneDisable = false;
        }
      });
    },
    editVideo(video) {
      if (video.video_url) {
        this.video_upload_type = 2;
        this.temp_video_url = video.video_url;
        this.editValue = video.video_url;
      } else {
        if (video.file) {
          this.editValue = video.file;
        } else {
          this.editValue = video.filename;
        }

        this.video_upload_type = 1;
        this.dropzoneDisable = false;
      }
      this.form.lecture_information = video.lecture_information;
      this.form.video_name = video.video_name;
      window.$('.add_update').text('Update Video');
      this.isEditVideo = true;
      this.showVideoUploadModal = true;
    },
    addUploadVideo() {
      if (this.video_upload_type == 1) {
        if (this.isEditVideo) {
          if (this.temp_lecture_video && this.temp_lecture_video.length) {
            let tempVideo = this.temp_lecture_video[0];
            let tempVideoName = this.temp_lecture_original_video[0];

            let lecturePreview = this.lecture_preview_videos.find((object) => {
              return object.filename === this.editValue;
            });

            if (lecturePreview) {
              lecturePreview.file = tempVideoName.original_filename;
              lecturePreview.original_file = tempVideo.name;
              lecturePreview.lecture_information =
                this.form.lecture_information;
              lecturePreview.video_name = this.form.video_name;
            }

            let lectureVideo = this.lecture_videos.find((object) => {
              return object.file === this.editValue;
            });

            let previousFileName = this.editValue;

            if (lectureVideo) {
              lectureVideo.file = tempVideoName.original_filename;
              lectureVideo.original_file = tempVideo.name;
              lectureVideo.lecture_information = this.form.lecture_information;
              lectureVideo.video_name = this.form.video_name;
              lectureVideo.previous_filename = previousFileName;
            }

            this.isTempFile = true;
            this.$refs.myVueDropzone.removeFile(tempVideo);
            this.temp_lecture_video = '';
            this.temp_lecture_original_video = '';
          } else {
            let lecturePreview = this.lecture_preview_videos.find((object) => {
              return object.filename === this.editValue;
            });
            if (lecturePreview) {
              lecturePreview.lecture_information =
                this.form.lecture_information;
              lecturePreview.video_name = this.form.video_name;
            }

            let lectureVideo = this.lecture_videos.find((object) => {
              return object.file === this.editValue;
            });
            if (lectureVideo) {
              lectureVideo.lecture_information = this.form.lecture_information;
              lectureVideo.video_name = this.form.video_name;
            }
          }
        } else {
          if (this.temp_lecture_video && this.temp_lecture_video.length) {
            let tempVideo = this.temp_lecture_video[0];
            let tempVideoName = this.temp_lecture_original_video[0];

            let lectureOriginalFile = {
              file: tempVideoName.original_filename,
              original_file: tempVideo.name,
              lecture_information: this.form.lecture_information,
              video_name: this.form.video_name,
            };

            this.lecture_videos.push(lectureOriginalFile);
            this.temp_lecture_preview_video = lectureOriginalFile;

            this.isTempFile = true;
            this.$refs.myVueDropzone.removeFile(tempVideo);
            this.lecture_preview_videos.push(this.temp_lecture_preview_video);
            this.temp_lecture_video = '';
            this.temp_lecture_original_video = '';
          }
        }
      } else {
        if (this.isEditVideo) {
          if (this.temp_video_url) {
            let url = this.temp_video_url;
            let singleUrl = url.split(',');
            if (singleUrl[0]) {
              let lecturePreview = this.lecture_preview_videos.find(
                (object) => {
                  return object.video_url === this.editValue;
                }
              );

              if (lecturePreview) {
                lecturePreview.lecture_information =
                  this.form.lecture_information;
                lecturePreview.video_name = this.form.video_name;
                lecturePreview.video_url = singleUrl[0];
              }

              let lectureVideoUrl = this.lecture_video_url.find((object) => {
                return object.video_url === this.editValue;
              });

              let previous_url = this.editValue;

              if (lectureVideoUrl) {
                lectureVideoUrl.lecture_information =
                  this.form.lecture_information;
                lectureVideoUrl.video_name = this.form.video_name;
                lectureVideoUrl.video_url = singleUrl[0];
                lectureVideoUrl.previous_url = previous_url;
              }
            } else {
              let lecturePreview = this.lecture_preview_videos.find(
                (object) => {
                  return object.video_url === this.editValue;
                }
              );

              if (lecturePreview) {
                lecturePreview.lecture_information =
                  this.form.lecture_information;
                lecturePreview.video_name = this.form.video_name;
              }

              let lectureVideoUrl = this.lecture_video_url.find((object) => {
                return object.video_url === this.editValue;
              });

              if (lectureVideoUrl) {
                lectureVideoUrl.lecture_information =
                  this.form.lecture_information;
                lectureVideoUrl.video_name = this.form.video_name;
              }
            }
          } else {
            let lecturePreview = this.lecture_preview_videos.find((object) => {
              return object.video_url === this.editValue;
            });

            if (lecturePreview) {
              lecturePreview.lecture_information =
                this.form.lecture_information;
              lecturePreview.video_name = this.form.video_name;
            }

            let lectureVideoUrl = this.lecture_video_url.find((object) => {
              return object.video_url === this.editValue;
            });

            if (lectureVideoUrl) {
              lectureVideoUrl.lecture_information =
                this.form.lecture_information;
              lectureVideoUrl.video_name = this.form.video_name;
            }
          }
        } else {
          if (this.lecture_preview_videos.length < 1) {
            if (this.temp_video_url) {
              let url = this.temp_video_url;
              let singleUrl = url.split(',');

              if (singleUrl[0]) {
                let lectureUrlVideo = {
                  video_url: singleUrl[0],
                  lecture_information: this.form.lecture_information,
                  video_name: this.form.video_name,
                };

                this.lecture_preview_videos.push(lectureUrlVideo);
                this.lecture_video_url.push(lectureUrlVideo);
              }
            }
          }
        }
      }
      this.showVideoUploadModal = false;
      this.temp_video_url = '';
      this.form.lecture_information = '';
      this.form.video_name = '';
    },
    openModalWithType(type) {
      this.type = type;
      this.openModal = true;
    },
    specialLectureExamData(data) {
      if (data.length) {
        this.selectedSpecialLectureExams = data;
      }
    },
    closeModal() {
      this.openModal = false;
      this.videoModalShow = false;
      this.showVideoUploadModal = false;
      this.temp_video_url = '';
      this.form.lecture_information = '';
      this.form.video_name = '';
    },
    showVideo(smil) {
      this.videoSmilFile = smil;
      this.videoModalShow = true;
    },
    submit() {
      if (this.isUpload) {
        this.showFailMsg('비디오 업로드가 아직 완료되지 않았습니다.');
        return;
      }
      this.allErrors = null;
      this.loading = true;

      if (this.selectedSpecialLectureExams) {
        this.form.exam_id = this.selectedSpecialLectureExams.map(
          (exam) => exam.id
        );
      }

      this.form.special_lecture_category_id = this.$route.params.id;

      if (this.$route.name === 'special_lecture_edit') {
        this.loading = true;
        this.errors = null;

        let formData = new FormData();

        Object.keys(this.form).forEach((key) => {
          formData.append(key, this.form[key] ? this.form[key] : '');
        });

        formData.append('lecture_videos', JSON.stringify(this.lecture_videos));
        formData.append(
          'lecture_video_url',
          JSON.stringify(this.lecture_video_url)
        );
        formData.append('attachments', JSON.stringify(this.form.attachments));
        formData.append('images', JSON.stringify(this.form.images));

        formData.append('_method', 'PATCH');

        this.axios
          .post(
            '/special-lectures/' + this.$route.params.lecture_id,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }
          )
          .then(() => {
            this.$router.push({
              name: 'special_lecture_list',
              params: { id: this.$route.params.id },
            });
            this.showSuccessMsg(this.$t('common.updateSuccess'));
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        let formData = new FormData();

        Object.keys(this.form).forEach((key) => {
          formData.append(key, this.form[key] ? this.form[key] : '');
        });

        formData.append('lecture_videos', JSON.stringify(this.lecture_videos));
        formData.append(
          'lecture_video_url',
          JSON.stringify(this.lecture_video_url)
        );
        formData.append('attachments', JSON.stringify(this.form.attachments));
        formData.append('images', JSON.stringify(this.form.images));

        this.axios
          .post('/special-lectures/', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => {
            this.$router.push({
              name: 'special_lecture_list',
              params: { id: this.$route.params.id },
            });
            this.showSuccessMsg(this.$t('common.addSuccess'));
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.active {
  color: #78cb5b;
}

.inactive {
  color: #fff000;
}

.fa.fa-circle:before {
  content: '\25C9';
  /*color: #000;*/
}

th {
  text-align: center;
}

td:nth-child(1) {
  text-align: center;
}

td:nth-child(3) {
  text-align: center;
}

td:nth-child(2) {
  padding-left: 40px;
}

.event-active {
  font-weight: bold;
  color: #78cb5b;
  text-transform: uppercase;
  letter-spacing: 1.2px;
}
.dropzone_disable {
  pointer-events: none;
  cursor: default;
}
.dropzone_disable .dropzone .dz-message {
  display: none !important;
}
.video_list .video_type {
  text-align: center !important;
  display: block;
}
.dropzone_disable {
  pointer-events: none;
  cursor: default;
}
.dropzone_disable .dropzone .dz-message {
  display: none !important;
}
.video_list .video_type {
  text-align: center !important;
  display: block;
}
.create_images_drag {
  position: relative;
  width: 100%;
  background: #efefef;
  min-height: 212px;
  margin-bottom: 10px;
}

.create_images_drag span {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #999;
}
.inner {
  border: 1px solid #e2e2e2 !important;
}
.red_border {
  border: 1px solid red !important;
}
</style>
